import { render, staticRenderFns } from "./LuckyRollEditor.vue?vue&type=template&id=1324b3e3&"
import script from "./LuckyRollEditor.vue?vue&type=script&lang=js&"
export * from "./LuckyRollEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports